let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bL0B7")).then(() => parcelRequire('3xy6E'));